import { createSelector } from 'reselect'

import * as constants from './constants'

// Org settings selectors
export const assistantOrgSettings = state => state.getIn(['assistantSettings', 'orgSettings', 'data'])

export const fetchAssistantOrgSettingsPending = state =>
  state.getIn(['assistantSettings', 'orgSettings', 'status']) ===
  constants.FETCH_ASSISTANT_ORG_SETTINGS_PENDING

export const fetchAssistantOrgSettingsSuccess = state =>
  state.getIn(['assistantSettings', 'orgSettings', 'status']) ===
  constants.FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS

export const fetchAssistantOrgSettingsFailed = state =>
  state.getIn(['assistantSettings', 'orgSettings', 'status']) ===
  constants.FETCH_ASSISTANT_ORG_SETTINGS_FAILED

export const patchAssistantOrgSettingsPending = state =>
  state.getIn(['assistantSettings', 'orgSettings', 'status']) ===
  constants.PATCH_ASSISTANT_ORG_SETTINGS_PENDING

export const patchAssistantOrgSettingsSuccess = state =>
  state.getIn(['assistantSettings', 'orgSettings', 'status']) ===
  constants.PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS

export const patchAssistantOrgSettingsFailed = state =>
  state.getIn(['assistantSettings', 'orgSettings', 'status']) ===
  constants.PATCH_ASSISTANT_ORG_SETTINGS_FAILED

// Agent settings selectors
export const assistantAgentSettings = state =>
  state.getIn(['assistantSettings', 'agentSettings', 'data', 'taskConfigMap'])

export const fetchAssistantAgentSettingsPending = createSelector(
  state => state.getIn(['assistantSettings', 'AgentSettings', 'status', 'fetch']),
  fetchAssistantAgentSettingsStatus =>
    fetchAssistantAgentSettingsStatus === constants.FETCH_ASSISTANT_AGENT_SETTINGS_PENDING
)

export const fetchAssistantAgentSettingsSuccess = createSelector(
  state => state.getIn(['assistantSettings', 'AgentSettings', 'status', 'fetch']),
  fetchAssistantAgentSettingsStatus =>
    fetchAssistantAgentSettingsStatus === constants.FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS
)

export const fetchAssistantAgentSettingsFailed = createSelector(
  state => state.getIn(['assistantSettings', 'AgentSettings', 'status', 'fetch']),
  fetchAssistantAgentSettingsStatus =>
    fetchAssistantAgentSettingsStatus === constants.FETCH_ASSISTANT_AGENT_SETTINGS_FAILED
)

// Salesforce settings selectors
export const salesforceLeadSettings = state =>
  state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'LEAD'])
export const salesforceContactSettings = state =>
  state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'CONTACT'])
export const salesforceEventSettings = state =>
  state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'EVENT'])
export const salesforceTaskSettings = state =>
  state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'TASK'])

export const fetchSalesforceSettingsPending = createSelector(
  state => state.getIn(['assistantSettings', 'salesforceMappings', 'status']),
  fetchSalesforceSettingsStatus =>
    fetchSalesforceSettingsStatus === constants.FETCH_SALESFORCE_SETTINGS_PENDING
)

export const fetchSalesforceSettingsSuccess = createSelector(
  state => state.getIn(['assistantSettings', 'salesforceMappings', 'status']),
  fetchSalesforceSettingsStatus =>
    fetchSalesforceSettingsStatus === constants.FETCH_SALESFORCE_SETTINGS_SUCCESS
)

export const fetchSalesforceSettingsFailed = createSelector(
  state => state.getIn(['assistantSettings', 'salesforceMappings', 'status']),
  fetchSalesforceSettingsStatus =>
    fetchSalesforceSettingsStatus === constants.FETCH_SALESFORCE_SETTINGS_FAILED
)

export const fetchPersonalizationTagsSuccess = createSelector(
  state => state.getIn(['assistantSettings', 'personalizationTags', 'status']),
  fetchPersonalizationTagsStatus =>
    fetchPersonalizationTagsStatus === constants.FETCH_PERSONALIZATION_TAGS_SUCCESS
)

export const personalizationTags = state =>
  state.getIn(['assistantSettings', 'personalizationTags', 'data'])

// Editing selectors
export const isEditingMapping = state => state.getIn(['assistantSettings', 'editingOrgSettings', 'MAPPING'])
export const isEditingActivity = state => state.getIn(['assistantSettings', 'editingOrgSettings', 'ACTIVITY'])

export const editingAssistantAgentSettings = state =>
  state.getIn(['assistantSettings', 'editingAgentSettings'])


export const assistantConfigHasEdits = createSelector(
  [assistantAgentSettings, editingAssistantAgentSettings],
  (assistantAgentSettings, editingAssistantAgentSettings) => {
    return !assistantAgentSettings.equals(editingAssistantAgentSettings)
  }
)

export const sendTestEmailPending = state =>
  state.getIn(['assistantSettings', 'sendingTestEmailStatus']) ===
  constants.SEND_TEST_EMAIL_PENDING

export const sendTestEmailSuccess = state =>
  state.getIn(['assistantSettings', 'sendingTestEmailStatus']) ===
  constants.SEND_TEST_EMAIL_SUCCESS

export const sendTestEmailFailed = state =>
  state.getIn(['assistantSettings', 'sendingTestEmailStatus']) ===
  constants.SEND_TEST_EMAIL_FAILED



// WEBPACK FOOTER //
// ./src/scripts/app/modules/assistantSettings/selectors.js